export const ADDTOCART = "addtocart";
export const ADD = "add";
export const LESS = "less";
